import { render } from "./DateField.vue?vue&type=template&id=ff3a6a4c"
import script from "./DateField.vue?vue&type=script&lang=ts"
export * from "./DateField.vue?vue&type=script&lang=ts"

import "./DateField.vue?vue&type=style&index=0&id=ff3a6a4c&lang=scss"
script.render = render

export default script